import React from 'react';
import { FormattedNumber } from 'react-intl';

export function formatPrice(price = '') {
  // eslint-disable-next-line
  return (
    <FormattedNumber
      style="currency"
      currency="USD"
      minimumFractionDigits={2}
      maximumFractionDigits={2}
      value={price}
    />
  );
}

export function formatPriceWithoutCents(price = '') {
  // eslint-disable-next-line
  return (
    <FormattedNumber
      style="currency"
      currency="USD"
      minimumFractionDigits={0}
      maximumFractionDigits={0}
      value={price}
    />
  );
}
